import { getLoginName } from '@/utils/util'

export const BILL_TYPE = 'ATTRIBUTE_STOCK'
export const REPORT_TITLE = '多属性库存统计'

export const defColumns = [
  {
    title: '序号', dataIndex: 'rowIndex', width: 50, align: 'center',
    customRender: function(t, r, index) {
      return (t !== '合计') ? (parseInt(index) + 1) : t
    }
  },
  {
    title: '库存流水', dataIndex: 'action', width: 80, align: 'center',
    scopedSlots: { customRender: 'actionCustomRender' }
  },
  { title: '条码', dataIndex: 'barCode', width: 120, ellipsis: true },
  { title: '名称', dataIndex: 'name', width: 150, ellipsis: true },
  { title: '规格', dataIndex: 'standard', width: 80, ellipsis: true },
  { title: '型号', dataIndex: 'model', width: 80, ellipsis: true },
  { title: '类别', dataIndex: 'categoryName', width: 80, ellipsis: true },
  { title: '单位', dataIndex: 'unit', width: 50 },
  { title: '多属性', dataIndex: 'sku', width: 100, ellipsis: true },
  { title: '扩展信息', dataIndex: 'expand', width: 100, ellipsis: true },
  { title: '成本价', dataIndex: 'purchaseDecimal', width: 80, align: 'right' },
  { title: '多属性库存', dataIndex: 'skuStock', width: 90, align: 'right' },
  { title: '库存金额', dataIndex: 'skuStockPrice', width: 90, align: 'right' }
]

export function buildPrintData(dataSource, queryParam, userInfo, companyInfo) {
  // 步骤1：提取合计行
  const totalRow = (dataSource || []).find(item => item.rowIndex === '合计')
  // 步骤2：过滤合计行，映射数据行
  const rows = (dataSource || [])
    .filter(item => item.rowIndex !== '合计')
    .map((item, idx) => ({
      rowIndex: idx + 1,
      barCode: item.barCode || '',
      name: item.name || '',
      standard: item.standard || '',
      model: item.model || '',
      categoryName: item.categoryName || '',
      unit: item.unit || '',
      sku: item.sku || '',
      expand: item.expand || '',
      purchaseDecimal: item.purchaseDecimal || 0,
      skuStock: item.skuStock || 0,
      skuStockPrice: item.skuStockPrice || 0
    }))
  // 步骤3：追加合计行
  if (totalRow) {
    rows.push({
      rowIndex: '合计',
      barCode: '', name: '', standard: '', model: '',
      categoryName: '', unit: '', sku: '', expand: '',
      purchaseDecimal: '-',
      skuStock: totalRow.skuStock || 0,
      skuStockPrice: totalRow.skuStockPrice || 0
    })
  }
  return {
    reportTitle: REPORT_TITLE,
    reportDate: new Date().toLocaleDateString(),
    dateRange: '',
    table: rows,
    total_skuStock: 0,
    total_skuStockPrice: 0,
    creatorName: getLoginName(),
    companyName: (companyInfo && companyInfo.companyName) || '',
    companyAddress: (companyInfo && companyInfo.companyAddress) || '',
    companyTel: (companyInfo && companyInfo.companyTel) || '',
    companyFax: (companyInfo && companyInfo.companyFax) || ''
  }
}